
// src/helpers/gamba-url.js

import config from '../config'

export default function (url) {
  return url.match(`${config.baseUrl}n`)
}



// WEBPACK FOOTER //
// ./src/helpers/gamba-url.js